<template>
  <button
    class="link text-theme flex items-center space-x-1"
    @click="openSiteCart()"
  >
    <span class="w-5 h-5">
      <CartMenuIcon />
    </span>
    <span
      v-if="!isLoading && cart"
      class="font-bold"
      data-testid="cart-qty"
      >{{ cart.totalQty }}</span
    >
    <span class="sr-only">Cart</span>
  </button>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import CartMenuIcon from "../../../templates/_includes/svg/icon-cart.svg";

export default {
  name: "SiteCartMenuItem",

  components: { CartMenuIcon },

  computed: mapState("cart", ["cart", "error", "isLoading"]),

  methods: mapMutations(["openSiteCart"]),
};
</script>
